var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "custom-callout",
        {
          staticClass: "mb-4",
          attrs: { "border-color": "green", "has-toggle": false }
        },
        [
          _c(
            "validation-observer",
            { ref: "searchValidator", attrs: { novalidate: "", tag: "form" } },
            [
              _c("div", { staticClass: "mt-3 container-search" }, [
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 pl-0" },
                      [
                        _c("icon-view", {
                          staticClass: "mx-0 mb-2",
                          attrs: {
                            icon: "fas fa-file-plus",
                            "icon-background": "#fff",
                            "icon-color": "#2db782",
                            "icon-size": "14px",
                            title: "Añadir Tarjeta"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row mr-md-1" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-8 pl-0" },
                      [
                        _c("span", { staticClass: "title-add-card" }, [
                          _vm._v("Número de Estudiante:")
                        ]),
                        _c("validation-provider", {
                          ref: "searchText",
                          attrs: {
                            "custom-messages": {
                              required: "El número de SIE es requerido.",
                              studentSie: "El número de SIE no es correcto."
                            },
                            rules: "required|studentSie"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    staticClass: "pt-2",
                                    attrs: {
                                      id: "searchText",
                                      "custom-error-msg": errors[0],
                                      error: errors[0],
                                      maxlength: "8",
                                      placeholder: "Escriba número de SIE",
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.searchText,
                                      callback: function($$v) {
                                        _vm.searchText = $$v
                                      },
                                      expression: "searchText"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-3 pt-2" },
                      [
                        _c(
                          "action-button",
                          {
                            attrs: {
                              i: "fa fa-search ",
                              text: "searchText",
                              variant: "success btn-block mt-4"
                            },
                            on: { click: _vm.search }
                          },
                          [_vm._v(" Buscar ")]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          ),
          _vm.studentSelected
            ? _c("div", [
                _c("span", { staticClass: "row mt-3 mb-3" }, [
                  _c("i", {
                    staticClass:
                      "fas fa-info-circle custom-color-icon mr-2 mt-1"
                  }),
                  _c(
                    "span",
                    { staticClass: "title-icon-view font-16 font-weight-bold" },
                    [_c("strong", [_vm._v("Información del Estudiante")])]
                  )
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "row col-12 mt-2 white-panel pr-5 border-left pt-3 pl-5"
                  },
                  [
                    _c("div", { staticClass: "col-sm-12 col-md-2 px-0" }, [
                      _c("span", { staticClass: "title-add-card" }, [
                        _vm._v("Nombre:")
                      ]),
                      _c("p", [_vm._v(_vm._s(this.studentFullName))])
                    ]),
                    _c("div", { staticClass: "col-sm-12 col-md-2 px-0" }, [
                      _c("span", { staticClass: "title-add-card" }, [
                        _vm._v("SIE:")
                      ]),
                      _c("p", [_vm._v(_vm._s(this.selectedStudent.studentId))])
                    ]),
                    _c("div", { staticClass: "col-sm-12 col-md-2 px-0" }, [
                      _c("span", { staticClass: "title-add-card" }, [
                        _vm._v("Edad:")
                      ]),
                      _c("p", [_vm._v(_vm._s(this.studentAge))])
                    ]),
                    _c("div", { staticClass: "col-sm-12 col-md-2 px-0" }, [
                      _c("span", { staticClass: "title-add-card" }, [
                        _vm._v("Fecha de Nacimiento:")
                      ]),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.formatDate(this.selectedStudent.birthdate))
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "col-sm-12 col-md-3 px-0" }, [
                      _c("span", { staticClass: "title-add-card" }, [
                        _vm._v("SSN:")
                      ]),
                      _c("br"),
                      _c("span", [
                        !_vm.showSsnNumber
                          ? _c("span", { staticClass: "pl-1" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.ssnFormat(this.selectedStudent.ssn)
                                  ) +
                                  " "
                              )
                            ])
                          : _vm._e(),
                        _vm.showSsnNumber
                          ? _c("span", { staticClass: "pl-1" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.ssnFormat(
                                      this.selectedStudent.ssnNumber
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          : _vm._e(),
                        _vm.userCanViewSsn && !_vm.showSsnNumber
                          ? _c("i", {
                              staticClass:
                                "mt-1 ml-2 fa fa-eye-slash cursor-pointer",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.onShowSsn()
                                }
                              }
                            })
                          : _vm._e(),
                        _vm.userCanViewSsn && _vm.showSsnNumber
                          ? _c("i", {
                              staticClass: "mt-1 ml-2 fa fa-eye cursor-pointer",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.onShowSsn()
                                }
                              }
                            })
                          : _vm._e()
                      ])
                    ]),
                    _c("div", { staticClass: "col-12 px-0 col-md-1" }, [
                      _c("span", { staticClass: "title-add-card ml-5" }, [
                        _vm._v("Estatus:")
                      ]),
                      _c("p", { staticClass: "ml-5" }, [
                        _vm._v(_vm._s(this.selectedStudent.status))
                      ])
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _c("br"),
          _vm.showCardFields ? _c("hr") : _vm._e(),
          _c(
            "div",
            { staticClass: "container-form" },
            [
              _c(
                "validation-observer",
                {
                  ref: "addCardFormValidator",
                  attrs: { novalidate: "", tag: "form" }
                },
                [
                  _vm.showCardFields
                    ? _c("div", { staticClass: "row col-12 mt-3 py-3 px-0" }, [
                        _c("div", { staticClass: "row col-12 mb-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-4 mb-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "title-add-card mb-2" },
                                [_vm._v(" Año Académico: ")]
                              ),
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-drop-down", {
                                            attrs: {
                                              clearable: false,
                                              "custom-error-msg":
                                                "El año académico es requerido.",
                                              error: errors[0],
                                              fieldkey: "id",
                                              fieldname: "description",
                                              options:
                                                _vm.catalog.academicYears,
                                              placeholder:
                                                "Seleccione año academico"
                                            },
                                            on: {
                                              input: _vm.onAcademicYearChanged
                                            },
                                            model: {
                                              value: _vm.selectedAcademicYear,
                                              callback: function($$v) {
                                                _vm.selectedAcademicYear = $$v
                                              },
                                              expression: "selectedAcademicYear"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2525549697
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-4 mb-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "title-add-card font-14 mb-2" },
                                [_vm._v(" Región Educativa: ")]
                              ),
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-drop-down", {
                                            attrs: {
                                              clearable: false,
                                              "custom-error-msg":
                                                "La región educativa es requerida.",
                                              error: errors[0],
                                              fieldkey: "id",
                                              fieldname: "name",
                                              options: _vm.catalog.regions,
                                              placeholder: "Seleccione"
                                            },
                                            on: { input: _vm.onRegionChanged },
                                            model: {
                                              value: _vm.card.region,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.card,
                                                  "region",
                                                  $$v
                                                )
                                              },
                                              expression: "card.region"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  758418795
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-4 mb-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "title-add-card mb-2" },
                                [_vm._v(" Centro: ")]
                              ),
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-drop-down", {
                                            attrs: {
                                              clearable: false,
                                              "custom-error-msg":
                                                "El centro es requerido.",
                                              error: errors[0],
                                              fieldkey: "id",
                                              fieldname: "name",
                                              options: _vm.catalog.centers,
                                              placeholder: "Seleccione"
                                            },
                                            on: { input: _vm.onCenterChanged },
                                            model: {
                                              value: _vm.card.center,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.card,
                                                  "center",
                                                  $$v
                                                )
                                              },
                                              expression: "card.center"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1606320491
                                )
                              })
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "row col-12 mb-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-4" },
                            [
                              _c(
                                "div",
                                { staticClass: "title-add-card mb-2" },
                                [_vm._v(" Municipio: ")]
                              ),
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-drop-down", {
                                            attrs: {
                                              clearable: false,
                                              "custom-error-msg":
                                                "El muncipio es requerido.",
                                              error: errors[0],
                                              fieldkey: "id",
                                              fieldname: "name",
                                              options:
                                                _vm.catalog.municipalities,
                                              placeholder: "Seleccione"
                                            },
                                            on: {
                                              input: _vm.onMunicipalityChanged
                                            },
                                            model: {
                                              value: _vm.card.municipality,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.card,
                                                  "municipality",
                                                  $$v
                                                )
                                              },
                                              expression: "card.municipality"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  611742450
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-4 mb-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "title-add-card mb-2" },
                                [_vm._v(" Escuela: ")]
                              ),
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-drop-down", {
                                            attrs: {
                                              clearable: false,
                                              "custom-error-msg":
                                                "La escuela es requerida.",
                                              error: errors[0],
                                              fieldkey: "id",
                                              fieldname: "name",
                                              options: _vm.catalog.schools,
                                              placeholder: "Seleccione"
                                            },
                                            model: {
                                              value: _vm.card.school,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.card,
                                                  "school",
                                                  $$v
                                                )
                                              },
                                              expression: "card.school"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  626212669
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-4 mb-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "title-add-card mb-2" },
                                [_vm._v(" Estatus de la Tarjeta: ")]
                              ),
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-drop-down", {
                                            attrs: {
                                              clearable: false,
                                              "custom-error-msg":
                                                "El estatus de la tarjeta es requerido.",
                                              error: errors[0],
                                              fieldkey: "id",
                                              fieldname: "name",
                                              options: _vm.cardStatuses,
                                              placeholder: "Seleccione"
                                            },
                                            model: {
                                              value: _vm.card.status,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.card,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "card.status"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1730328915
                                )
                              })
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "row col-12 mt-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-4 offset-8 text-right" },
                            [
                              _c(
                                "action-button",
                                {
                                  staticClass: "flex-grow-1",
                                  attrs: {
                                    i: "fas fa-times-circle",
                                    variant:
                                      "outline-danger btn-cancel danger m-2"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.closeAddCard()
                                    }
                                  }
                                },
                                [_vm._v(" Cancelar ")]
                              ),
                              _c(
                                "action-button",
                                {
                                  staticClass: "flex-grow-1",
                                  attrs: {
                                    i: "fas fa-file-plus",
                                    variant: "success"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addCardHandler()
                                    }
                                  }
                                },
                                [_vm._v(" Añadir ")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }